import { CFormInput, CModal, CModalContent, CSpinner } from "@coreui/react";
import { FormEvent } from "react";
import { general } from "../../../locales/general";
import { useUploadMenu } from "./hooks";

interface Props {
  visible: boolean;
  onClose: () => void;
  placeId: string;
}

export default function MenuModal({ visible, onClose, placeId }: Props) {
  const { upload, isUploading } = useUploadMenu(placeId, onClose);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    upload(new FormData(e.currentTarget).get("menu") as File);
  };

  return (
    <CModal visible={visible} onClose={onClose} alignment="center">
      <CModalContent className="p-3">
        <h5 className="fs-5 my-4">Ajouter un menu</h5>
        <form onSubmit={handleSubmit} className="row">
          <div className="col">
            <label htmlFor="menu">Menu</label>
            <CFormInput
              required
              name="menu"
              id="menu"
              type="file"
              accept="application/pdf"
              className="w-100"
            />
          </div>
          <button className="btn-danger btn shadow-primary mt-4 d-flex align-items-center justify-content-center text-white">
            {isUploading ? (
              <>
                <CSpinner size="sm" /> {general.fr.wait}
              </>
            ) : (
              "Enregistrer le menu"
            )}
          </button>
        </form>
      </CModalContent>
    </CModal>
  );
}